import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import ApexCharts from 'apexcharts';
import moment from 'moment';

import styled from 'styled-components';
import { Box, Text } from '@ies-ds/react-ui';

export const WhiteText = styled(Text)`
  color: #fff;
`;

const StyledButton = styled.div`
  display: inline-block;
  border: 1px solid rgba(200, 200, 200, 0.5);
  font-size: 12px;
  font-weight: 400;
  padding: 4px 8px;
  border-radius: 2px;
  &:hover {
    cursor: pointer;
    background: #fde500;
    color: #000;
  }
`;

export default function ApexChart({
  id = 'defaultID',
  type = 'area',
  height = 260,
  title,
  color,
  units,
  toolbar = false,
  yTicks = 2,
  strokeShow = true,
  dataActual = [45, 52, 38, 44, 52, 38, 44],
  orange = [45, 52, 38, 24, 33, 26, 21, 20, 6, 8, 15, 10],
  yellow = [45, 52, 38, 24, 33, 26, 21, 20, 6, 8, 15, 10],
  timestamps = ['01 Jan', '02 Jan', '03 Jan'],
  toFixed = 0,
  minRange = -1000000000000,
  maxRange = 1000000000000,
}) {
  useEffect(() => {
    //ApexCharts.exec('SC000058', 'updateSeries', dataActual);
    setChartData({
      series: [
        {
          name: '',
          data: dataActual,
        },
        // {
        //   name: 'Orange',
        //   data: orange,
        // },
        // {
        //   name: 'Yellow',
        //   data: yellow,
        // },
      ],
      options: {
        colors: [
          function ({ value, seriesIndex, w }) {
            if (value >= minRange && value <= maxRange) {
              return color;
            } else {
              return 'rgb(239, 68, 67)';
            }
          },
        ],
        //colors: [color, '#FFA500', '#FFFF00', '#E91E63', '#FF9800'],
        zoom: {
          type: 'x',
          enabled: true,
          autoScaleYaxis: true,
        },
        chart: {
          id: id,

          height: 100,
          type: 'line',
          zoom: {
            enabled: true,
          },
          animations: {
            enabled: false,
          },
          toolbar: {
            show: toolbar,
            offsetX: 0,
            offsetY: 0,
            tools: {
              download: false,
              selection: true,
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: true,
              reset: true | '<img src="/static/icons/reset.png" width="20">',
              customIcons: [],
            },
            export: {
              csv: {
                filename: undefined,
                columnDelimiter: ',',
                headerCategory: 'category',
                headerValue: 'value',
                dateFormatter(timestamp) {
                  return new Date(timestamp).toDateString();
                },
              },
              svg: {
                filename: undefined,
              },
              png: {
                filename: undefined,
              },
            },
            autoSelected: 'zoom',
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: strokeShow,
          width: [2, 2],
          curve: 'straight',
          dashArray: [8, 3, 5],
        },
        title: {
          text: '',
          align: 'left',
          style: {
            color: '#999',
            fontSize: '12px',
            fontFamily: 'Helvetica, Arial, sans-serif',
            fontWeight: 600,
            cssClass: 'apexcharts-xaxis-title',
          },
        },
        legend: {
          show: true,
          // tooltipHoverFormatter: function (val, opts) {
          //   return (
          //     val +
          //     ' - ' +
          //     opts.w.globals.series[opts.seriesIndex][
          //       opts.dataPointIndex
          //     ] +
          //     ''
          //   );
          // },
          labels: {
            colors: '#aaa',
            useSeriesColors: false,
          },
        },
        yaxis: {
          tickAmount: yTicks,
          labels: {
            style: {
              colors: '#64748b',
            },
            formatter: function (value) {
              return value == null ? '0' : value.toFixed(toFixed) + ' ' + units;
            },
          },
        },
        markers: {
          size: 0,
          hover: {
            sizeOffset: 6,
          },
        },
        xaxis: {
          // min: '2022-08-05T00:00:00Z',
          // max: '2022-09-15T00:00:00Z',
          zoomX: {},
          type: 'datetime',
          tickAmount: 3,
          labels: {
            datetimeUTC: true,
            style: {
              colors: '#64748b',
            },
          },
          axisBorder: {
            show: true,
            color: '#333',
            height: 1,
            width: '100%',
            offsetX: 0,
            offsetY: 0,
          },
          axisTicks: {
            show: true,
            borderType: 'solid',
            color: '#999',
            height: 6,
            offsetX: 0,
            offsetY: 0,
          },
          categories: timestamps,
        },
        tooltip: {
          theme: 'dark',
          x: {
            format: 'dd MMM yyyy, h:mm',
            formatter: function (value, { series, seriesIndex, dataPointIndex, w }) {
              return moment(value).zone('+0100').format('MMM yyyy');
            },
          },
          y: [
            {
              title: {
                formatter: function (val) {
                  return val + '';
                },
              },
            },
            {
              title: {
                formatter: function (val) {
                  return val + '';
                },
              },
            },
            {
              title: {
                formatter: function (val) {
                  return val;
                },
              },
            },
          ],
        },
        grid: {
          show: true,
          borderColor: 'rgba(255,255,255,0.1)',
          strokeDashArray: [4, 5],
        },
      },
    });
  }, [dataActual]);

  const [chartData, setChartData] = useState({
    series: [
      {
        name: '',
        data: dataActual,
      },
      // {
      //   name: 'Orange',
      //   data: orange,
      // },
      // {
      //   name: 'Yellow',
      //   data: yellow,
      // },
    ],
    options: {
      colors: [color, '#FFA500', '#FFFF00', '#E91E63', '#FF9800'],
      zoom: {
        type: 'x',
        enabled: true,
        autoScaleYaxis: true,
      },
      chart: {
        id: id,

        height: 100,
        type: 'line',
        zoom: {
          enabled: true,
        },
        animations: {
          enabled: false,
        },
        toolbar: {
          show: toolbar,
          offsetX: 0,
          offsetY: 0,
          tools: {
            download: false,
            selection: true,
            zoom: true,
            zoomin: true,
            zoomout: true,
            pan: true,
            reset: true | '<img src="/static/icons/reset.png" width="20">',
            customIcons: [],
          },
          export: {
            csv: {
              filename: undefined,
              columnDelimiter: ',',
              headerCategory: 'category',
              headerValue: 'value',
              dateFormatter(timestamp) {
                return new Date(timestamp).toDateString();
              },
            },
            svg: {
              filename: undefined,
            },
            png: {
              filename: undefined,
            },
          },
          autoSelected: 'zoom',
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: strokeShow,
        width: [2, 2],
        curve: 'straight',
        dashArray: [8, 3, 5],
      },
      title: {
        text: '',
        align: 'left',
        style: {
          color: '#999',
          fontSize: '12px',
          fontFamily: 'Helvetica, Arial, sans-serif',
          fontWeight: 600,
          cssClass: 'apexcharts-xaxis-title',
        },
      },
      legend: {
        show: true,
        // tooltipHoverFormatter: function (val, opts) {
        //   return (
        //     val +
        //     ' - ' +
        //     opts.w.globals.series[opts.seriesIndex][
        //       opts.dataPointIndex
        //     ] +
        //     ''
        //   );
        // },
        labels: {
          colors: '#aaa',
          useSeriesColors: false,
        },
      },
      yaxis: {
        tickAmount: yTicks,
        labels: {
          style: {
            colors: '#64748b',
          },
          formatter: function (value) {
            return value == null ? '0' : value.toFixed(0) + ' ' + units;
          },
        },
      },
      markers: {
        size: 0,
        hover: {
          sizeOffset: 6,
        },
      },
      xaxis: {
        // min: '2022-08-05T00:00:00Z',
        // max: '2022-09-15T00:00:00Z',
        zoomX: {},
        type: 'datetime',
        tickAmount: 3,
        labels: {
          datetimeUTC: true,
          style: {
            colors: '#64748b',
          },
        },
        axisBorder: {
          show: true,
          color: '#333',
          height: 1,
          width: '100%',
          offsetX: 0,
          offsetY: 0,
        },
        axisTicks: {
          show: true,
          borderType: 'solid',
          color: '#999',
          height: 6,
          offsetX: 0,
          offsetY: 0,
        },
        categories: timestamps,
      },
      tooltip: {
        theme: 'dark',
        x: {
          format: 'dd MMM yyyy, h:mm',
          formatter: function (value, { series, seriesIndex, dataPointIndex, w }) {
            return moment(value).zone('+0100').format('ddd D MMM yyyy, H:mm');
          },
        },
        y: [
          {
            title: {
              formatter: function (val) {
                return val + '';
              },
            },
          },
          {
            title: {
              formatter: function (val) {
                return val + '';
              },
            },
          },
          {
            title: {
              formatter: function (val) {
                return val;
              },
            },
          },
        ],
      },
      grid: {
        show: true,
        borderColor: 'rgba(255,255,255,0.1)',
        strokeDashArray: [4, 5],
      },
    },
  });

  return (
    <>
      {' '}
      <WhiteText weight="bold" style={{ marginLeft: '20px', color: color }}>
        {' '}
        {title}
      </WhiteText>
      <Chart options={chartData.options} series={chartData.series} type={type} height={height} />
    </>
  );
}
